import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useState } from 'react';

export default function CommunityTabs({ handleChangeSort, setShowAbout }) {
  const [active, setActive] = useState(1);

  return (
    <Paper square>
      <Tabs
        fullWidth
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
        onChange={(event, newValue) => {
          if (newValue === 0) setShowAbout(true);
          else setShowAbout(false);
          if (newValue === 1)
            handleChangeSort({
              title: 'Newest',
              orderby: 'createdAt',
            });
          else if (newValue === 2)
            handleChangeSort({
              title: 'Rating',
              orderby: 'score',
            });
          else if (newValue === 3)
            handleChangeSort({
              title: 'Random',
              orderby: 'random',
            });
          setActive(newValue);
        }}
        value={active}
      >
        <Tab label="About" />
        <Tab label="New" />
        <Tab label="Top" />
        <Tab label="Discover" />
      </Tabs>
    </Paper>
  );
}
